import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce } from 'intact-vue';
import { makeItemStyles } from './styles';
import { getRestProps } from '../utils';
var _$tmp0 = {
  'd': 'M64 896V128h896v768H64z m64-128l192-192 116.352 116.352L640 448l256 307.2V192H128v576z m224-480a96 96 0 1 1-0.064 192.064A96 96 0 0 1 352 288z'
};
var _$tmp1 = {
  'viewBox': '0 0 1024 1024',
  'xmlns': 'http://www.w3.org/2000/svg'
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _ItemklsObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    type = _this$get.type;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-skeleton-item"] = true, _classNameObj[makeItemStyles(k)] = true, _classNameObj);
  var ItemklsObj = (_ItemklsObj = {}, _ItemklsObj[k + "-skeleton-item-box"] = true, _ItemklsObj[k + "-skeleton-item-" + type] = true, _ItemklsObj);
  var skeletonItem = _$cv('div', _extends({
    'className': _$cn(ItemklsObj)
  }, getRestProps(this)), type === 'image' ? _$ce(512, 'svg', _$ce(2, 'path', null, 1, null, _$tmp0), 2, null, _$tmp1) : undefined);
  return _$ce(2, 'div', skeletonItem, 0, _$cn(classNameObj));
}
;